import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ToolbarTitle } from '@f/components/shared/toolbar/Toolbar';

import cls from './Sidebar.module.scss';

export type SidebarProps = {
  children?: React.ReactNode;
  className?: string;
  title: string;
};

export function Sidebar(props: SidebarProps) {
  const { children, className, title } = props;

  return (
    <div className={cx(cls.sidebar, className)}>
      <ToolbarTitle className={cls.toolbarTitle}>{title}</ToolbarTitle>
      <div className={cls.content}>{children}</div>
    </div>
  );
}

Sidebar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
};
